import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import joinClassNames from './joinClassNames.js'

export function Modal({
  open,
  onClose,
  titleId,
  describedById,
  overlayClassName = '',
  contentClassName = '',
  children,
}) {
  useEffect(() => {
    if (!open) return undefined
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [open])

  useEffect(() => {
    if (!open) return undefined
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  if (!open) return null

  return createPortal(
    <div className={joinClassNames('modal-overlay', overlayClassName)} onClick={onClose}>
      <div
        className={joinClassNames('modal-content', contentClassName)}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={describedById}
        onClick={(event) => event.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  )
}

export function ModalHeader({ className = '', ...props }) {
  return <div className={joinClassNames('modal-header', className)} {...props} />
}

export function ModalBody({ className = '', ...props }) {
  return <div className={joinClassNames('modal-body', className)} {...props} />
}

export function ModalFooter({ className = '', ...props }) {
  return <div className={joinClassNames('modal-footer', className)} {...props} />
}
